import axios from 'axios';
const localStorageHelper = require('./local-storage');

import { API_URL, HTTP_STATUS_CODES } from './config';

const apiClient = async (url, method, data = {}, options = { redirectOnUnauthorized: true }, params= {}) => {
  const token = localStorageHelper.getToken();
  const fullUrl = `${API_URL}/${url}`;
  try {
    const response = await axios({
      method,
      url: fullUrl,
      headers: {
        Authorization: token
      },
      data,
      params
    });
    return response;
  } catch (err) {
    switch (err.response.status) {
      case HTTP_STATUS_CODES.UNAUTHORIZED:
        if (options.redirectOnUnauthorized) {
          localStorageHelper.clearLocalStorage();
          window.location.href = `${window.location.origin}/login`;
        }
        break;
      case HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY:
        break;
      case HTTP_STATUS_CODES.INTERNAL_ERROR:
        break;
    }
    return err.response;
  }
};

export { apiClient };
